import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import { baseURL } from './api/apiClient';
import { tokenService } from './features/auth/token.service';

i18n
  .use(initReactI18next)
  .use(Backend)
  .init({
    lng: 'en',
    fallbackLng: 'en',
    saveMissing: true,
    backend: {
      addPath: `${baseURL}/translations/{{lng}}/{{ns}}`,
      loadPath: `${baseURL}/translations/{{lng}}/{{ns}}.json`,
      customHeaders: () => ({
        Authorization: `Bearer ${tokenService.getAccessToken()}`
      })
    },
    react: {
      useSuspense: false
    },
    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

export default i18n;
